import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import axiosAuth from "../../../axiosAuth";
import { SCHOOL_INSTALLMENTS_CALCULATION_UPDATE } from "../../apiRoutes";

export interface UpdateInstallmentPayload {
  schoolId: string;
  installmentIndex: number;
  year?: string;
  installmentNumber?: string;
  tds?: boolean;
  expectedDueDate?: string | null;
  installmentAmount?: string;
  gstPercentage?: string;
  installmentAmountNonGst?: string;
  installmentAmountGst?: string;
  totalInvoiceAmount?: string;
  
  // PDC Details
  pdcYear?: string;
  pdcNumber?: string;
  pdcAmount?: string;
  pdcDate?: string | null;
  pdcStatus?: string;
  pdcAmountReceived?: string;
  pdcClearedDate?: string | null;
  pdcRemarks?: string;
  
  // Invoice Lifecycle
  expectedInvoiceGenerationDate?: string | null;
  expectedInvoiceSubmissionDate?: string | null;
  expectedInvoiceClearanceDate?: string | null;
  invoiceGenerationDate?: string | null;
  invoiceCode?: string;
  invoiceFile?: File | string | null;
  invoiceOwner?: string;
  bankAccountDetails?: string;
  invoiceSubmissionDate?: string | null;
  invoiceRemark?: string;
}

export const useUpdateInstallmentCalculationMutation = (options?: { onSuccess?: () => void , onError?: () => void }) => {
  return useMutation({
    mutationFn: async (payload: UpdateInstallmentPayload) => {
      const { schoolId, installmentIndex, ...rest } = payload as any;

      const bodyWithNulls = {
        ...rest,
      } as Record<string, unknown>;

      const body = Object.fromEntries(
        Object.entries(bodyWithNulls).filter(([, v]) => v !== null && v !== undefined)
      );

      const response = await axiosAuth.put(
        `${SCHOOL_INSTALLMENTS_CALCULATION_UPDATE}${installmentIndex}/`,
        body
      );
      return response.data;
    },
    onSuccess: () => {
      toast.success("Installment Calculations updated successfully!");
      options?.onSuccess?.();
    },
    onError: (error: any) => {
      const message =
        error?.response?.data?.issues?.message || error?.response?.data?.message || "Failed to update installment";
      toast.error(message);
      options?.onError?.();

    },
  });
};
